/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechCamPhotoIcon20Solid = forwardRef('TechCamPhotoIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.5 10.25a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 4a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3h-1.25l-.585-1.17A1.5 1.5 0 0 0 11.823 2H8.177a1.5 1.5 0 0 0-1.342.83L6.25 4H5Zm5 2.25a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" })));
});
